require("./sitio");

// slide
import '@splidejs/splide/dist/css/splide.min.css';
// slide
const Splide = require('@splidejs/splide').default;

let slide_proceso_compra = new Splide("#slide-proceso-compra", {
    // type: "loop",
    perPage: 4,
    autoplay: false,
    arrows: true,
    perMove: 1,
    pagination: false,
    breakpoints: {
        1100: {
            perPage: 3,
        },
        800: {
            perPage: 2,
        },
        540: {
            perPage: 1,
        },
    },
}).mount();

$(document).ready(function () {
    function mueveLinea() {
        const $etapa = $("#etapas").find(".active");
        const $linea = $("#contenidos").find(".vertical");
        const container_ancho = $(".container").width();
        const ancho_ventana = $(window).width();
        const margenes = ancho_ventana - container_ancho;
        const offset = $etapa.offset();
        const ancho_etapa = $etapa.width();
        $linea.css("margin-left", offset.left - margenes / 2 + ancho_etapa / 2);
    }

    $(".ver-info").on("click", function () {
        const id_etapa = $(this).data("etapa");
        const $etapa = $(this).parents(".etapa");
        const $contenido = $("#contenidos").find(`.etapa-${id_etapa}`);
        $("#contenidos").slideDown(function () {
            $("#etapas").find(".etapa").removeClass("active");
            $("#contenidos")
                .find(".etapa")
                .not(".active")
                .removeClass("active")
                .slideUp();
            $etapa.addClass("active");
            $contenido.slideDown().addClass("active");
            mueveLinea();
        });
        $(this).blur();
    });

    $(window).on("resize", function () {
        mueveLinea();
    });

    mueveLinea();
});
